namespace AgerLMS.LMS {
    export interface PrintCargoAddressStickerRequest extends Serenity.ServiceRequest {
        OrderGuid?: string;
        UserAddress?: AddressesRow;
    }
}
